"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _styles = require("@material-ui/core/styles");
var _theme = _interopRequireDefault(require("../../theme"));
const useStyles = (0, _styles.makeStyles)({
  closeButton: {
    position: 'absolute',
    top: '20px',
    right: '20px',
    cursor: 'pointer',
    height: '56px',
    width: '56px',
    background: 'rgba(0, 0, 0, 0.4)',
    borderRadius: '50%',
    border: 'none',
    textIndent: '100%',
    overflow: 'hidden',
    color: 'transparent',
    whiteSpace: 'nowrap',
    transition: 'transform 0.365s, opacity 0.365s, -webkit-transform 0.365s',
    zIndex: '10002',
    transform: 'scale(0)',
    opacity: 0,
    '&::before': {
      content: '',
      position: 'absolute',
      top: '50%',
      left: '50%',
      height: '2px',
      width: '24px',
      background: _theme.default.palette.white,
      transform: 'translate(-50%) rotate(45deg)'
    },
    '&::after': {
      content: '',
      position: 'absolute',
      top: '50%',
      left: '50%',
      height: '2px',
      width: '24px',
      background: _theme.default.palette.white,
      transform: 'translate(-50%) rotate(45deg)'
    },
    '&:hover': {
      background: 'rgba(0, 0, 0, 0.6)'
    }
  },
  closeButtonActive: {
    transform: 'scale(1)',
    opacity: 1
  },
  container: {
    position: 'fixed',
    top: 0,
    left: 0,
    height: '100%',
    width: '100%',
    pointerEvents: 'none',
    opacity: 0,
    visibility: 'hidden',
    zIndex: 10000
  },
  containerActive: {
    pointerEvents: 'initial',
    opacity: 1,
    visibility: 'visible'
  },
  body: {
    background: _theme.default.palette.white,
    position: 'relative',
    height: '100%',
    overflow: 'auto',
    padding: '6rem 15%',
    zIndex: 10001,
    opacity: 0
  },
  bodyActive: {
    opacity: 1
  },
  noBodyPadding: {
    padding: 0
  },
  placeholder: {
    position: 'fixed',
    top: 0,
    left: 0,
    opacity: 0,
    transitionProperty: 'transform, opacity',
    transitionDuration: '0.001s'
  }
});
var _default = exports.default = useStyles;